query GetVIQDashboard($input: DashboardInput!) {
    viqDashboard(input: $input) {
        totalCount
        stats {
            name
            formattedValue
            formattedPreviousValue
            delta {
                percentChange
                timespanSuffix
                direction
            }
            timespanString
        }
        originId
    }
}
